import { AppAreaConfig } from '@/funnels/@types'
import walkingFemale from './activity-female-walking'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-walking-japanese',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['japanese_walking'],
	},
	landing: {
		ids: ['loader-walking-japanese-f', 'age-walking-japanese-f'],
		route: {
			path: '/walking-japanese-f',
			name: 'walking-japanese-funnel',
		},
	},
	funnel: {
		id: 'ob-female-activity-walking-japanese',
		route: {
			path: '/walking-japanese-f/ob/:page*',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-activity-walking-japanese',
		},
		slug: 'activity-female-walking-japanese',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: walkingFemale,
				page: 'body-focus-areas',
			},
		},
	},
}

export default appAreaConfig
